import { Header } from "@/types/VDataTable";
export const headers: Header[] = [
  {
    text: "Vessel Name & IMO",
    type: "string",
    align: "left",
    value: "vesselName",
    class: "veselName",
    sortable: true,
  },
  {
    text: "Vessel Group",
    type: "string",
    align: "left",
    value: "vesselGroup",
    sortable: true,
    class: "vesselGroup",
    width: "180px",
  },
  {
    text: "Performance status",
    type: "indicator:performance",
    align: "left",
    value: "performance",
    sortable: true,
    class: "performance",
    width: "225px",
  },
  {
    text: "Last Data Observed",
    type: "string",
    align: "left",
    value: "lastDataObserved",
    sortable: true,
    class: "lastDataObserved",
    width: "200px",
  },
  {
    text: "Alerts",
    type: "indicator:alert",
    align: "left",
    value: "alert",
    sortable: true,
    class: "alerts",
    width: "220px",
  },
];
